import { VincularGrupoModuloInterface } from "../../../Interfaces/Geral/Grupos/GruposModulosInterfaces";

import {
    ListarGruposComModulosService,
    ListarModulosVinculadosPorGrupoService,
    ListarModulosNaoVinculadosPorGrupoService,
    DesvincularGrupoModuloService,
    VincularGrupoModuloService,
} from "../../../Services/Geral/Grupos/GruposModulosService";

import { Controller } from "../../Controller";

export function ListarGruposComModulosController() {
    return Controller(ListarGruposComModulosService());
}

export function ListarModulosVinculadosPorGrupoController(iDGrupo: number) {
    return Controller(ListarModulosVinculadosPorGrupoService(iDGrupo));
}

export function ListarModulosNaoVinculadosPorGrupoController(iDGrupo: number) {
    return Controller(ListarModulosNaoVinculadosPorGrupoService(iDGrupo));
}

export function DesvincularGrupoModuloController(IDGrupoModulo: number) {
    return Controller(DesvincularGrupoModuloService(IDGrupoModulo));
}

export function VincularGrupoModuloController(
    props: VincularGrupoModuloInterface
) {
    return Controller(VincularGrupoModuloService(props));
}
